import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Card, Button, Form, InputGroup } from "react-bootstrap";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { useNavigate, useParams } from "react-router-dom";

function ProductPage() {
  const [subgroup, setsubgroup] = useState([]);
  const [files, setFiles] = useState([]);
  const [items, setitems] = useState([]);
  const navigate = useNavigate();
  const { subGroupId } = useParams();
  const [cartItems, setCartItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const loadData = async () => {
      try {
          const response = await adminInstance.get(`subgroup/GetSubGroupById/${subGroupId}`);
          setsubgroup(response.data.subGroup);
          setitems(response.data.items);
          setFiles(JSON.parse(response.data.subGroup?.Files) || []);
      } catch (error) {
          console.error('Error fetching orders:', error.message);
      } finally {
          console.log('Fetch process completed.');
      }
  };

  useEffect(() => {
    loadData();    
    const existingCart = JSON.parse(sessionStorage.getItem('CartItems')) || [];
    setCartItems(existingCart);
  }, []);

  const addToCart = (product) => {
    const existingCart = JSON.parse(sessionStorage.getItem('CartItems')) || [];
    const existingItemIndex = existingCart.findIndex(item => item.ItemCode === product.ItemCode);
  
    if (existingItemIndex !== -1) {
      existingCart[existingItemIndex].quantity += 1;
    } else {
      existingCart.push({ ...product, quantity: 1 });
    }
  
    sessionStorage.setItem('CartItems', JSON.stringify(existingCart));
    setCartItems(existingCart); // Refresh state
    alert(`${product.ItemCode} added to cart!`);
  };

  const goToCheckout = () => {
    navigate("/checkout");
  }

  const chunkArray = (arr, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      chunks.push(arr.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const filteredItems = items.filter(spare =>
    spare.ItemCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    spare.ItemName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="card aon-card">
        <div className="card-header aon-card-header">
            <h4>
                Product Detail
            </h4>
        </div>
        <div className="card-body aon-card-body">
          <Container className="mt-4">
            {/* Product Header */}
            <Row>
              <Col md={3}>
                <img src={subgroup.Img} alt={subgroup.SubGroupName} className="img-fluid" />
              </Col>
              <Col md={9}>
                <h2>{subgroup.SubGroupName}</h2>
                <strong>Part Number: {subgroup.SubGroupCode}</strong>
                <p>{subgroup.Description}</p>
              </Col>
            </Row>

            {/* Spares List */}
            <Row className="mt-4">
              <Col>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h4 className="mb-0">Item List</h4>
                  <Button variant="warning" onClick={() => goToCheckout()}>
                    Proceed to Checkout
                  </Button>
                </div>

                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Part Number</th>
                      <th>Item</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={4}>
                        <InputGroup className="mb-3">
                          <Form.Control
                            placeholder="Search Items..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                          />
                        </InputGroup>
                      </td>
                    </tr>
                    {filteredItems.map((spare, index) => (
                      <tr key={spare.ItemCode}>
                        <td>{index + 1}</td>
                        <td>{spare.ItemCode}</td>
                        <td>{spare.ItemName}</td>
                        <td>
                          {cartItems.some(item => item.ItemCode === spare.ItemCode) ? (
                            <Button variant="success" disabled>
                              Already in Cart
                            </Button>
                          ) : (
                            <Button variant="primary" onClick={() => addToCart({ ItemCode: spare.ItemCode, ItemName: spare.ItemName })}>
                              Add to Cart
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Button variant="warning" onClick={() => goToCheckout()}>
                            Proceed to Checkout
                          </Button>
              </Col>
            </Row>

            {/* Additional Images */}
            <Row className="mt-4">
              <Col>
                <h4>Additional Images</h4>
                <Row>
                  {[subgroup.Img1, subgroup.Img2, subgroup.Img3].map((img, index) =>
                    img ? (
                      <Col key={index} md={4}>
                        <Card>
                          <Card.Img variant="top" src={img} />
                        </Card>
                      </Col>
                    ) : null
                  )}
                </Row>
              </Col>
            </Row>

            {/* Attachments */}
            <Row className="mt-4">
              <Col>
                <h4>Attachments</h4>
                {chunkArray(files, 3).map((rowFiles, rowIndex) => (
                  <Row key={rowIndex} className="mb-2">
                    {rowFiles.map((file, colIndex) =>
                      file ? (
                        <Col key={colIndex}>
                          <a href={file} download target="_blank" rel="noopener noreferrer">
                            {file.split('\\').pop()}
                          </a>
                        </Col>
                      ) : (
                        <Col key={colIndex}></Col>
                      )
                    )}
                  </Row>
                ))}                
              </Col>
            </Row>

            {/* YouTube Videos */}
            <Row className="mt-4">
              <Col>
                <h4>Product Videos</h4>
                <Row>
                  {[subgroup.Vid1, subgroup.Vid2, subgroup.Vid3].map((video, index) => (
                    <Col key={index} md={4}>
                      <div className="embed-responsive embed-responsive-16by9">
                        <iframe
                          className="embed-responsive-item"
                          src={video}
                          title={`Video ${index + 1}`}
                          allowFullScreen
                        ></iframe>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
    </div>
    </div>
  );
};

export default ProductPage;
